<template>
  <div>
    <div class="container">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="錄音流通" label-width="100px">
              <el-select
                v-model="queryForm.recshare"
                size="small"
                class="selectqry"
                filterable
              >
                <el-option
                  v-for="item in myRecshares"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                style="width: 150px"
                v-model="queryForm.qstr"
                placeholder="編號、班名、名稱、序號、備註"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="editDeptMbr"
            size="small"
            >編輯錄音流通成員</el-button
          >
          <el-button
            type="primary"
            @click="importMember"
            size="small"
            >人員匯入</el-button>
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 錄音流通：{{
          getRecshareName(activeQueryForm.recshare)
        }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="recshareMembers"
            @sort-change="sortChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="index" :index="indexFormatter" fixed>
            </el-table-column>

            <!--<el-table-column label="所屬單位/錄音流通" prop="orgName" width="150">-->
            <!--<template #default>-->
            <!--{{ myownOrg }} /-->
            <!--{{ getRecshareName(activeQueryForm.recshare) }}-->
            <!--</template>-->
            <!--</el-table-column>-->

            <el-table-column
              label="人員編號"
              prop="no"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ scope.row.member.no }}
              </template>
            </el-table-column>

            <el-table-column
              label="班級名稱"
              prop="className"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ scope.row.member.className }}
              </template>
            </el-table-column>
            <el-table-column
              label="月光機序號"
              prop="moonlight2SerialNumber"
              width="200"
            >
              <template #default="scope">
                {{ scope.row.member.moonlight2SerialNumber }}
              </template>
            </el-table-column>
            <el-table-column
              label="人員名稱"
              prop="name"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ scope.row.member.name }}
              </template>
            </el-table-column>
         <el-table-column
              label="備註"
              prop="memo"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ scope.row.member.memo }}
              </template>
            </el-table-column>

            <el-table-column label="允許上傳檔案" width="140">
              <template #default="scope">
                <el-switch
                  :value="scope.row.isUploadable"
                  active-text="是"
                  inactive-text="否"
                  :disabled="true"
                >
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template #default="scope">

                <!--<el-button size="mini" disabled>審核 </el-button>-->

                <el-button
                  type="danger"
                  size="mini"
                  @click="quitRecshare(scope.row.id)"
                  >移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>

        <EditRecshareMbrDlg
          v-model="isDlgVisible"
          :recshareId="activeQueryForm.recshare"
          :recshareName="getRecshareName(activeQueryForm.recshare)"
          :key="`edtDeptMbr_${dlgKey}`"
        ></EditRecshareMbrDlg>

        <EditMbrGroupDlg
          v-model="isEditMbrGrpDlgVisible"
          :memberId="selectedItemId"
          :memberNo="selectMemberNo"
          :memberName="selectedMemberName"
          :deptId="activeQueryForm.recshare"
          :deptName="getRecshareName(activeQueryForm.recshare)"
          :key="`edtMbrGrp_${editMbrGrpDlgKey}`"
        ></EditMbrGroupDlg>

        <MbrSubsMgmtDlg
          v-model="isMbrSubsDlgVisible"
          :deptMemberId="selectedItemId"
          :memberName="selectedMemberName"
          :key="`mbrSubs_${mbrSubsDlgKey}`"
        ></MbrSubsMgmtDlg>
        <RecshareImportMbrDlg
          v-model="isImportDlgVisible"
          :key="`import_${importDlgKey}`"
        ></RecshareImportMbrDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import API from "@/api";
import { mapGetters } from "vuex";
import EditRecshareMbrDlg from "@/components/recshare/EditRecshareMbrDlg";
import EditMbrGroupDlg from "@/components/dept/EditMbrGroupDlg";
//import MemberSubsDlg from "@/components/dept/MemberSubsDlg";
import MbrSubsMgmtDlg from "../components/dept/MbrSubsMgmtDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
import RecshareImportMbrDlg from "@/components/recshare/RecshareImportMbrDlg";
export default {
  name: "recshareMemberList",
  mixins: [tagColorsMixin],
  components: {
    EditRecshareMbrDlg,
    EditMbrGroupDlg,
    MbrSubsMgmtDlg,
    RecshareImportMbrDlg,
  },
  created() {
    API.my.recshares().then((res) => {
      this.myRecshares = res.data;
      this.queryForm.recshare = res.data[0].id;
      this.activeQueryForm.recshare = res.data[0].id;


      this.$store.commit("recshareMember/CLEAR");
      this.$store.commit("recshareMember/SET_SORT", this.defaultSortCol);
      this.$store.commit("recshareMember/SET_ORDER", this.defaultOrder);
      this.query(this.pageSize, this.offset, this.sort, this.order, this.activeQueryForm);
    });
  },
  data() {
    return {
      defaultSortCol: "recshareMember.id",
      defaultOrder: 'ascending',
      selectedItemId: null,
      selectMemberNo: "",
      selectedMemberName: "",
      myRecshares: [],
      dlgKey: 0,
      editMbrGrpDlgKey: 0,
      mbrSubsDlgKey: 0,
      isDlgVisible: false,
      isEditMbrGrpDlgVisible: false,
      isMbrSubsDlgVisible: false,
      pageSize: 50,
      currentPage: 1,
      importDlgKey: 0,
      isImportDlgVisible: false,
      queryForm: {
        recshare: null,
        qstr: "",
      },
      activeQueryForm: {
        recshare: 0,
        qstr: "",
      },
    };
  },
  methods: {
    importMember() {
      this.isImportDlgVisible = true;
      this.importDlgKey = this.importDlgKey ? 0 : 1;
    },
    getRecshareName(recshareId) {
      const recshare = this.myRecshares.find((recshare) => recshare.id === recshareId);
      return recshare?.name ?? "";
    },
    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      this.query(this.pageSize, 0, this.sort, this.order, this.activeQueryForm);
    },
    editDeptMbr() {
      this.isDlgVisible = true;
      this.dlgKey = this.dlgKey ? 0 : 1;
    },
    mbrSubscribe(deptMbr) {
      this.isMbrSubsDlgVisible = true;
      this.mbrSubsDlgKey = this.mbrSubsDlgKey ? 0 : 1;
      this.selectedItemId = deptMbr.id;
      this.selectedMemberName = deptMbr.member.name;
    },
    editMbrGrp(deptMbr) {
      this.editMbrGrpDlgKey = this.editMbrGrpDlgKey ? 0 : 1;
      this.selectedItemId = deptMbr.member.id;
      this.selectMemberNo = deptMbr.member.no;
      this.selectedMemberName = deptMbr.member.name;
      this.isEditMbrGrpDlgVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },
    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
    query(max, offset, sort, order, params = {}) {
      this.$store.dispatch("recshareMember/list", {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      });
    },
    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },
    quitRecshare(itemId) {
      //console.log(`quitRecshare: id = ${JSON.stringify(itemId)}`)
      this.$confirm("此操作將永久將該成員移出錄音流通, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("recshareMember/remove", itemId).then(() => {
            this.query(
              this.pageSize,
              this.offset,
              this.sort,
              this.order,
              this.activeQueryForm
            );
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {});
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("recshare/SET_SORT", this.defaultSortCol);
        this.$store.commit("recshare/SET_ORDER", this.defaultOrder);
      } else {
        const newSort = "member." + args.prop;
        this.$store.commit("recshareMember/SET_SORT", newSort);
        this.$store.commit("recshareMember/SET_ORDER", args.order);
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      recshareMembers: "recshareMember/recshareMembers",
      total: "recshareMember/total",
      offset: "recshareMember/offset",
      getMemberById: "recshareMember/getMemberById",
      sort: "recshareMember/sort",
      order: "recshareMember/order",
    }),
  },
};
</script>

<style></style>
